import React from 'react';
import { type RestModalForwards } from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import {
  FunnelButton,
  FunnelButtonIcon,
  getSvgIcon,
} from '@bbkFunnelComponents/v2';

export const MultiCTAOtherActions: ReactFCC<{
  actions: RestModalForwards[];
  handleAction: (action: RestModalForwards) => void;
}> = ({ actions, handleAction }) => {
  return (
    <>
      {actions.map((ga, idx) => (
        <FunnelButton
          key={idx}
          data-part="cta"
          data-action-index={idx}
          onClick={() => handleAction(ga)}
          classes="d-flex align-items-center justify-content-center"
        >
          {ga.icon ? (
            <FunnelButtonIcon>
              {getSvgIcon(ga.icon.toLowerCase())}
            </FunnelButtonIcon>
          ) : null}
          {ga.text}
        </FunnelButton>
      ))}
    </>
  );
};
